// Author: Luis Booth - October 2018
// Componentization...

import React, { Component } from 'react';
import ModifyButton from 'js/components/global/ModifyButton';

class SummaryBlock extends Component {
  render() {

    const { title, modifyRoute, noModify, blockId = '', step = 5, hasFlights } = this.props;

    return (
      <div className="summary-block" id={`${blockId}`}>
        <div className="row between-sm bottom-sm">
          <div className={`${noModify ? 'sm-12' : 'sm-8'}`}>
            <h2 className="summary-heading d-inline-block util-no-margin">
              {title}
            </h2>
          </div>
          {
            !noModify &&
            <div className="sm-4 util-txt-right">
              <ModifyButton route={modifyRoute} step={step} currentStep={5} hasFlights={hasFlights} />
            </div>
          }
          <div className="sm-12">
            <hr className="with-underline" />
          </div>
        </div>
        <div className={`row column-row-md ${this.props.withOutReverse ? '' : 'wrap-reverse-sm'}`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

SummaryBlock.defaultProps = {
  title: '',
  modifyRoute: '#',
  withOutReverse: false,
};

export default SummaryBlock;



// WEBPACK FOOTER //
// ./js/components/step5/SummaryBlock.js